import React, { Component } from 'react';
import './App.css';
import WeatherSearch from './WeatherSearch';
import WeatherSaved from './WeatherSaved';
import WeatherCurrent from './WeatherCurrent';

// API key from https://openweathermap.org/
var OPEN_WEATHER_KEY = '12b253952eeffa490e8dd4df34803511';

var STORAGE_KEY = 'todoList';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cities: []
        };
    }

    handleFormSubmit(item) {
        var url = '';
        if (Number.isInteger(parseInt(item)) && item.length === 5) {
            url = 'https://api.openweathermap.org/data/2.5/weather?zip=' + item + '&units=imperial&APPID=' + OPEN_WEATHER_KEY;

        } else {
            url = 'https://api.openweathermap.org/data/2.5/weather?q=' + item + '&units=imperial&APPID=' + OPEN_WEATHER_KEY;
        }        fetch(url)
            .then((response) => {
                return response.json();

            })
            .then((json) => {
                this.setState({
                    name: json.name,
                    temp: json.main.temp,
                    short: json.weather[0].main,
                    long: json.weather[0].description,
                    icon: json.weather[0].icon
                });
            })
            .catch((error) => {
                window.alert("Enter a real city please!");
                this.setState({
                    name: null,
                    temp: null,
                    short: null,
                    long: null,
                    icon: null
                });
            });

    }
    componentDidMount() {
        var savedListSting = localStorage.getItem(STORAGE_KEY);
        var savedListArray = JSON.parse(savedListSting) || [];


        this.setState({
            cities: savedListArray


        });

        this.handleFormSubmit('Seattle');

    }

    handleFormSave(itemToAdd) {
        var existingWeather = this.state.cities;
        var newWeather = existingWeather.concat([ itemToAdd ]);

        this.setState({
            cities: newWeather
        });

        localStorage.setItem(STORAGE_KEY, JSON.stringify(newWeather));

    }

    handleItemRemoved(itemToRemove) {
        var existingList = this.state.cities;
        var newList = existingList.filter((item) => {
            return item !== itemToRemove;
        });

        this.setState({
            cities: newList

        });

        localStorage.setItem(STORAGE_KEY, JSON.stringify(newList));


    }

    render() {
        return (
            <div className = "App">
                <h1>My Weather App!</h1>
                <WeatherSearch
                    handleFormSubmit={(item) => {
                        this.handleFormSubmit(item);

                    }}

                    handleFormSave={(item) => {
                        this.handleFormSave(item);
                    }}
                />
                <WeatherCurrent
                    name={this.state.name}
                    temp={this.state.temp}
                    long={this.state.long}
                    short={this.state.short}
                    icon={this.state.icon}
                    isValidLocation={this.state.isValidLocation}
                />
                <WeatherSaved
                    cities={this.state.cities}
                    onItemRemoved={(item) => {
                        this.handleItemRemoved(item);

                    }}

                    onSavedItemClick={(item) =>{
                        this.handleFormSubmit(item);
                    }}

                />

            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js